<template>
  <div class="bar-box" ref="cleanCar">
    <div v-if="customerId === 19" class="msg-ball" @click="carFun('洗车机')">
      <div v-if="noDataqing" class="noData_xi"></div>
      <dl class="content">
        <dt class="xi"></dt>
        <dd>
          <p>
            洗车机
            <span class="blueFont num">
              {{ allWashCar }}
            </span>
            台
          </p>
          <p>
            今日冲洗
            <span class="blueFont num">
              {{ dayWashCarCount }}
            </span>
            次
          </p>
          <p>
            累计冲洗
            <span class="blueFont num">
              {{ allWashCarCount }}
            </span>
            次
          </p>
        </dd>
      </dl>
    </div>
    <div v-else-if="customerId !== 28" class="msg-ball" @click="carFun('洗车机')">
      <div v-if="noDataxi" class="noData_xi"></div>
      <dl class="content">
        <dt class="xi"></dt>
        <dd>
          <p>
            洗车机
            <span class="blueFont num">
              {{ allWashCar }}
            </span>
            台
          </p>
          <p>
            今日冲洗
            <span class="blueFont num">
              {{ dayWashCarCount }}
            </span>
            次
          </p>
          <p>
            累计冲洗
            <span class="blueFont num">
              {{ allWashCarCount }}
            </span>
            次
          </p>
        </dd>
      </dl>
    </div>
    <div v-if="customerId === 19" class="msg-ball" @click="carFun('清洁车')">
      <div v-if="noDataqing" class="noData_xi"></div>
      <dl class="content">
        <dt class="qing"></dt>
        <dd>
          <p>
            清洁车
            <span class="blueFont num">
              {{ allCar }}
            </span>
            台
          </p>
          <p>
            清扫污染点
            <span class="blueFont num">
              {{ dayCount }}
            </span>
            个
          </p>
          <p>
            清扫里程
            <span class="blueFont num">
              {{ allCount }}
            </span>
            公里
          </p>
        </dd>
      </dl>
    </div>
    <div v-else-if="customerId !== 20" class="msg-ball" @click="carFun('清洁车')">
      <div v-if="noDataqing" class="noData_xi"></div>
      <dl class="content">
        <dt class="qing"></dt>
        <dd>
          <p>
            清洁车
            <span class="blueFont num">
              {{ allCar }}
            </span>
            台
          </p>
          <p>
            清扫污染点
            <span class="blueFont num">
              {{ dayCount }}
            </span>
            个
          </p>
          <p>
            清扫里程
            <span class="blueFont num">
              {{ allCount }}
            </span>
            公里
          </p>
        </dd>
      </dl>
    </div>
  </div>
</template>
<script>
import cleanTable from "./components/clean_table";
import { mapState, mapGetters } from "vuex";

export default {
  components: { cleanTable },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: 'clean_new.vue',
      computedName: '清洁车组件',
      customerId: this.$store.state.customerId,
      SETINTER: null,
      //道路清洁
      dayWashCarCount: 0,
      allWashCar: 0,
      allWashCarCount: 0,
      //洗车台
      dayCount: 0,
      allCar: 0,
      allCount: 0,
      noData: false,
      noDataxi: false,
      noDataqing: false,
      car_type: "",
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
  },
  mounted() {
    // this.qingData();

    let w = $(this.$refs.cleanCar).outerWidth();
    let h = $(this.$refs.cleanCar).outerHeight();

    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });
  },
  unmounted() {
    clearInterval(this.SETINTER);
  },
  methods: {
    async qingData() {
      if (this.SETINTER) {
        clearTimeout(this.SETINTER);
      }
      let _this = this;
      let data = await _this.$apiUtils.get(
        "/newscreen/control/getVechiSchedule",
        {
          customerId: _this.customerId,
        }
      );
      let { dayWashCarCount, allWashCar, allWashCarCount } = data.carWash;
      let { cleanPoint, driverOut, distance } = data.vehSchedule;
      this.dayCount = cleanPoint;
      this.allCar = driverOut;
      this.allCount = distance;
      this.dayWashCarCount = dayWashCarCount;
      this.allWashCar = allWashCar;
      this.allWashCarCount = allWashCarCount;
      if (!this.allWashCar) {
        this.noDataxi = true;
      }
      if (!this.allCar) {
        this.noDataqing = true;
      }
      this.SETINTER = setTimeout(() => {
        this.qingData();
      }, 10 * 60 * 1000);
    },
    carFun(carType) {
      if (this.customerId === 19) {
        window.open("http://192.168.1.55:8083"); //山钢日照清洁运输和清洁车跳转
      } else {
        this.car_type = { carType: carType };
        this.$store.commit("dialogStatus", true);
        this.$popup.open(cleanTable, this.dialogCompontent, this, {
          dialog: this.car_type,
        });
      }
    },
    hidedialog() {
      $(this.dialogCompontent).hide();
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.bar-box {
  display: flex;
  justify-content: space-around;
  // padding: 20px 0px;
  position: relative;
  overflow: hidden;
  // top: 75px !important;
  .smline {
    top: 5px;
    left: 0;
    position: absolute;
    transform: translateX(-157px);
    animation: linerun 10s linear infinite;
    width: 157px;
    height: 190px;
    background-size: 157px 190px;
    background-position: 50%;
    background-repeat: no-repeat;
    background-image: url(./img/line.png);
  }
  @keyframes linerun {
    0% {
      // -webkit-transform: translateX(-180px);
      transform: translateX(-180px);
    }

    50% {
      opacity: 1;
      // -webkit-transform: translateX(168px);
      transform: translateX(202px);
    }

    to {
      opacity: 0;
      // -webkit-transform: translateX(168px);
      transform: translateX(584px);
    }
  }
  .msg-ball {
    width: 50%;
    position: relative;
    .noData_xi {
      // @include bg-box(112px,78px,"noData-xi.png");
      width: 112px;
      height: 78px;
      background-size: 100% 100%;
      background-repeat: no-repeat;
      background-image: url("./img/noData-xi.png");
      position: absolute;
      top: -30px;
      left: 2px;
    }
    & > dl {
      display: flex;
      align-items: center;
      dt {
        margin: 15px 15px 0 0;
        cursor: pointer;
      }
      dt.xi {
        @include bg-box(108px, 68px, "xiche.png");
        background-size: initial;
        background-position: 0 0;
        &:hover {
          background-image: url("./img/xiche.png");
          background-position: -114px 0;
        }
      }
      dt.qing {
        @include bg-box(108px, 68px, "qingjie.png");
        background-size: initial;
        background-position: 0 0;
        &:hover {
          background-image: url("./img/qingjie.png");
          background-position: -114px 0;
        }
      }
      dd {
        margin-left: 0px;
        p {
          font-size: 15px;
          padding: 3px 0;
          line-height: 30px;
          letter-spacing: 1px;
          white-space: nowrap;
          span {
            font-size: 25px;
          }
        }
      }
    }
  }
}
</style>
<style type="text/css">
.vjs-loading-spinner {
  display: none;
}
.video-player {
  width: 100%;
  height: 100%;
}
.vjs-control-bar,
.vjs-error-display,
.vjs-modal-dialog,
.video-js.vjs-paused .vjs-big-play-button {
  display: none !important;
}
.vjs-big-play-button {
  display: none;
}
video {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
</style>
